import { render, staticRenderFns } from "./DataCell.vue?vue&type=template&id=09d20a8e&scoped=true&lang=pug&"
import script from "./DataCell.vue?vue&type=script&lang=js&"
export * from "./DataCell.vue?vue&type=script&lang=js&"
import style0 from "./DataCell.vue?vue&type=style&index=0&id=09d20a8e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d20a8e",
  null
  
)

export default component.exports